import React, { useContext, useState } from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { FormContext } from "../context/FormContext";
import Step4Message from "./Step4Message";
import LogoWom from "../images/logowom.svg";
import Track from "../images/track.svg";
import LogoCyber from "../images/logo-cyber-light.svg";
import ModalC2cGeneric from './ModalC2cGeneric';

const HeaderWom = styled.header`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #2d1441;
  padding: 28px 15px 10px;
  @media (max-width: 480px) {
    padding: 28px 16px 10px;
  }
  .logowom {
    display: block;
    margin: 0 auto;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  max-width: 768px;
  margin-left: auto;
  margin-right: auto;
`;

const ContentTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  img{
    width: 100%;
    max-width: 143px;
    margin-right: 15px;
    margin-bottom: -15px;
  }
`;

const TitleSection = styled.h2`
  font-weight: bold;
  font-size: 22px;
  line-height: 30px;
  color: #ffffff;
  margin: 28px 0 5px;
  text-align: center;
  span{
    color: rgb(233, 32, 112);
  }
  strong{
    display: block;
  }
  @media(min-width: 767px){
    font-size: 24px;
  }
`;

const SubTitleSection = styled.h3`
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  margin: 0 0 25px;
  text-align: center;
  span{
    color: #E92070;
    font-weight: 600;
  }
`;
const BajadaInfo = styled.h3`
  font-size: 16px;
  line-height: 20px;
  color: #ffffff;
  margin: 0 0 25px;
  text-align: center;
  .contact-tel{
    color:#ffffff;
  }
  span{
    font-weight:bold;
    text-decoration:underline;
    cursor: pointer;
  }
`;

const Steps = styled.div`
  width: 100%;
  max-width: 160px;
  min-height: 40px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
  .tracks {
    width: 130px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 9;
  }
  .step {
    text-decoration: none;
    pointer-events: none;
    background-color: #2d1441;
    border: 2px solid #7c6c8a;
    box-sizing: border-box;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.174055);
    width: 24px;
    height: 24px;
    border-radius: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    &.active {
      width: 40px;
      height: 40px;
      border-radius: 20px;
      background-color: #ffffff;
      p {
        color: #381451;
      }
    }
    &:nth-child(2) {
      left: 0;
      right: auto;
    }
    &:nth-child(4) {
      left: auto;
      right: right;
    }
    p {
      color: #ffffff;
      font-weight: bold;
      font-size: 12px;
      line-height: 15px;
    }
  }
`;


const Header = ({isOpenC2c, setIsOpenC2c}) => {
  const { formData, setFormData } = useContext(FormContext);
  const [ openModalC2c, setOpenModalC2c ] = useState(false);
  
  return (
    <HeaderWom>
      <ModalC2cGeneric 
        isOpenC2c={openModalC2c}
        setIsOpenC2c={setOpenModalC2c}
      />
      <Wrapper>
        <img className="logowom" src={LogoWom} alt="wom header" />
        {formData.successFlow === false && (
          <>
            {(formData.selectedPlan === undefined)&& <TitleSection></TitleSection>}
            <ContentTitle>
              <div> 
                {formData.selectedPlan === undefined && <TitleSection></TitleSection>}
                {
                  (
                    formData.selectedPlan === "PlanMas400GB-WOM72" ||
                    formData.selectedPlan === "PlanWOMGBLibre" ||
                    formData.selectedPlan === "PlanMasLibre" ||
                    formData.selectedPlan === "PlanMasGBLibre" ||
                    formData.selectedPlan === "PlanMasGBLibrePlus" ||
                    formData.selectedPlan === "PlanWOM400GB-WOM64" ||
                    formData.selectedPlan === "PlanAcumula400GB" ||
                    formData.selectedPlan === "PlanMas400GB" ||
                    formData.selectedPlan === "PlanWOM400GB" ||
                    formData.selectedPlan === "PlanWOMLibre" ||
                    formData.selectedPlan === "PlanMas400Gigas" ||
                    formData.selectedPlan === "PlanMasGigasLibres" ||
                    formData.selectedPlan === "PlanMasGigasLibresPlus" ||
                    formData.selectedPlan === "WOMmasLibre" ||
                    formData.selectedPlan === "WOMmasLibrePlus" ||
                    formData.selectedPlan === "PlanGBLibre" ||
                    formData.selectedPlan === "PlanGBLibrePlus"
                  ) &&
                  <TitleSection>¡Suma una línea adicional a <span>$3.990 por 6 meses!</span></TitleSection>
                }
                {
                  (
                    formData.selectedPlan === "PlanWOM250GB" ||
                    formData.selectedPlan === "PlanWOM250GB-WOM62" ||
                    formData.selectedPlan === "PlanMas250GB" ||
                    formData.selectedPlan === "PlanMas250GB-WOM71" ||
                    formData.selectedPlan === "PlanAcumula200Gigas" ||
                    formData.selectedPlan === "PlanAcumula300GB" ||
                    formData.selectedPlan === "PlanMas250Gigas"
                  ) &&
                  <TitleSection>¡Suma una línea adicional a <span>$4.990 por 6 meses!</span></TitleSection>
                }
                {(formData.selectedPlan === "WOM7950dcto") && <TitleSection><strong>SOLO POR POCOS DÍAS</strong> ¡pórtate por <span>$7.990 por 6 meses!</span></TitleSection>}
                {(formData.selectedPlan === "WOM7950dctoM") && <TitleSection><strong>SOLO POR POCOS DÍAS</strong> ¡pórtate por <span>$7.990 por 6 meses!</span></TitleSection>}
                {(formData.selectedPlan === "OfertaWOM150gb") && <TitleSection>¡Suma una línea adicional a <span>$5.990 por 6 meses!</span></TitleSection>}
                {(formData.selectedPlan === "PlanWOM150Gigas") && <TitleSection>¡Suma una línea adicional a <span>$10.990 por 6 meses!</span></TitleSection>}
                {(formData.selectedPlan === "PILOTO_PlanWOM150Gigas") && <TitleSection>¡Suma una línea adicional a <span>$5.990 por 12 meses!</span></TitleSection>}
                {(formData.selectedPlan === "PlanWOM150Gigas-WOM86") && <TitleSection>¡Suma una línea adicional a <span>$9.990 por 6 meses!</span></TitleSection>}
                {(formData.selectedPlan === "WOMmas600Gigas") && <TitleSection>¡Suma una línea adicional a <span>$3.990 por 6 meses!</span></TitleSection>}
                {(formData.selectedPlan === "WOMmas400Gigas") && <TitleSection>¡Suma una línea adicional a <span>$4.990 por 6 meses!</span></TitleSection>}
                {(formData.selectedPlan === "WOMmas400GigasTactico") && <TitleSection>¡Suma una línea adicional a <span>$3.990 por 6 meses!</span></TitleSection>}
                {
                  (
                    formData.selectedPlan === "OfertaWOMmas300gb" ||
                    formData.selectedPlan === "OfertaWOMmas450gb" ||
                    formData.selectedPlan === "OfertaWOMmasgblibres" ||
                    formData.selectedPlan === "OfertaWOMmasgblibresplus"
                  ) &&
                  <TitleSection>¡LÍNEA ADICIONAL POR <span>$2.000 POR 6 MESES!</span></TitleSection>
                }
                {formData.selectedPlan === "150gb-ref" && <TitleSection>PORTA TU PLAN CON 40% DCTO.</TitleSection>}
                {formData.selectedPlan === undefined && <SubTitleSection></SubTitleSection>}
                {
                  (
                    formData.selectedPlan === "PlanWOM250GB-WOM62" ||
                    formData.selectedPlan === "PlanMas250GB" ||
                    formData.selectedPlan === "PlanMas250GB-WOM71" ||
                    formData.selectedPlan === "PlanMas400GB-WOM72" ||
                    formData.selectedPlan === "PlanWOMGBLibre" ||
                    formData.selectedPlan === "PlanMasLibre" ||
                    formData.selectedPlan === "PlanMasGBLibre" ||
                    formData.selectedPlan === "PlanMasGBLibrePlus" ||
                    formData.selectedPlan === "PlanAcumula200Gigas" ||
                    formData.selectedPlan === "PlanAcumula300GB" ||
                    formData.selectedPlan === "PlanWOM400GB-WOM64" ||
                    formData.selectedPlan === "PlanAcumula400GB" ||
                    formData.selectedPlan === "PlanMas400GB" ||
                    formData.selectedPlan === "PlanWOM250GB" ||
                    formData.selectedPlan === "PlanWOM400GB" ||
                    formData.selectedPlan === "PlanWOMLibre" ||
                    formData.selectedPlan === "PlanMas250Gigas" ||
                    formData.selectedPlan === "PlanMas400Gigas" ||
                    formData.selectedPlan === "PlanMasGigasLibres" ||
                    formData.selectedPlan === "PlanMasGigasLibresPlus" ||
                    formData.selectedPlan === "WOMmas300Gigas" ||
                    formData.selectedPlan === "WOMmas400Gigas" ||
                    formData.selectedPlan === "WOMmas400GigasTactico" ||
                    formData.selectedPlan === "WOMmas600Gigas" ||
                    formData.selectedPlan === "WOMmasLibre" ||
                    formData.selectedPlan === "WOMmasLibrePlus" ||
                    formData.selectedPlan === "PlanWOM150Gigas" ||
                    formData.selectedPlan === "OfertaWOM150gb" ||
                    formData.selectedPlan === "OfertaWOMmas300gb" ||
                    formData.selectedPlan === "OfertaWOMmas450gb" ||
                    formData.selectedPlan === "OfertaWOMmasgblibres" ||
                    formData.selectedPlan === "OfertaWOMmasgblibresplus" ||
                    formData.selectedPlan === "WOM7950dcto" ||
                    formData.selectedPlan === "WOM7950dctoM" ||
                    formData.selectedPlan === "PILOTO_PlanWOM150Gigas" ||
                    formData.selectedPlan === "PlanWOM150Gigas-WOM86" ||
                    formData.selectedPlan === "PlanGBLibre" ||
                    formData.selectedPlan === "PlanGBLibrePlus"
                  ) &&
                  <SubTitleSection>Porta o contrata y accede a esta oferta exclusiva para ti</SubTitleSection>
                }
                {formData.selectedPlan === "150gb-ref" && <SubTitleSection>¡Solo por pocos días! Oferta exclusiva para ti</SubTitleSection>}
              </div>
            </ContentTitle>

            {formData.selectedPlan === undefined && <BajadaInfo></BajadaInfo>}
            {/*
              (
                formData.selectedPlan === "250gb-app" ||
                formData.selectedPlan === "400gb-app" ||
                formData.selectedPlan === "gb-libres-app"
              ) &&
              <BajadaInfo>Si quieres que te llamemos para contratar este plan <span onClick={() => setOpenModalC2c(!openModalC2c)}>haz click aquí</span></BajadaInfo>
              */}
          </>
        )}
        {formData.successFlow === false ? (

          (
            formData.selectedPlan === undefined ||
            formData.selectedPlan === "PlanWOM250GB-WOM62" ||
            formData.selectedPlan === "PlanMas250GB" ||
            formData.selectedPlan === "PlanMas250GB-WOM71" ||
            formData.selectedPlan === "PlanMas400GB-WOM72" ||
            formData.selectedPlan === "PlanWOMGBLibre" ||
            formData.selectedPlan === "PlanMasLibre" ||
            formData.selectedPlan === "PlanMasGBLibre" ||
            formData.selectedPlan === "PlanMasGBLibrePlus" ||
            formData.selectedPlan === "PlanAcumula200Gigas" ||
            formData.selectedPlan === "PlanAcumula300GB" ||
            formData.selectedPlan === "PlanWOM400GB-WOM64" ||
            formData.selectedPlan === "PlanAcumula400GB" ||
            formData.selectedPlan === "PlanMas400GB" ||
            formData.selectedPlan === "PlanWOM250GB" ||
            formData.selectedPlan === "PlanWOM400GB" ||
            formData.selectedPlan === "PlanWOMLibre" ||
            formData.selectedPlan === "PlanMas250Gigas" ||
            formData.selectedPlan === "PlanMas400Gigas" ||
            formData.selectedPlan === "PlanMasGigasLibres" ||
            formData.selectedPlan === "PlanMasGigasLibresPlus" ||
            formData.selectedPlan === "WOMmas300Gigas" ||
            formData.selectedPlan === "WOMmas400Gigas" ||
            formData.selectedPlan === "WOMmas400GigasTactico" ||
            formData.selectedPlan === "WOMmas600Gigas" ||
            formData.selectedPlan === "WOMmasLibre" ||
            formData.selectedPlan === "WOMmasLibrePlus" ||
            formData.selectedPlan === "PlanWOM150Gigas" ||
            formData.selectedPlan === "OfertaWOM150gb" ||
            formData.selectedPlan === "OfertaWOMmas300gb" ||
            formData.selectedPlan === "OfertaWOMmas450gb" ||
            formData.selectedPlan === "OfertaWOMmasgblibres" ||
            formData.selectedPlan === "OfertaWOMmasgblibresplus" ||
            formData.selectedPlan === "WOM7950dcto" ||
            formData.selectedPlan === "WOM7950dctoM" ||
            formData.selectedPlan === "PILOTO_PlanWOM150Gigas" ||
            formData.selectedPlan === "PlanWOM150Gigas-WOM86" ||
            formData.selectedPlan === "PlanGBLibre" ||
            formData.selectedPlan === "PlanGBLibrePlus" ||
            formData.selectedPlan === "150gb-ref"
          )  
          ?
          <Steps>
            <picture className="tracks">
              <img src={Track} alt="track" />
              <img src={Track} alt="track" />
            </picture>
            <NavLink
              exact
              to="/"
              activeClassName="step active"
              className="step"
            >
              <p>1</p>
            </NavLink>
            <NavLink to="/paso2" activeClassName="step active" className="step">
              <p>2</p>
            </NavLink>
            <NavLink to="/paso3" activeClassName="step active" className="step">
              <p>3</p>
            </NavLink>
   
          </Steps>
          :
          undefined
        ) : (
          <Step4Message />
        )}
      </Wrapper>
    </HeaderWom>
  );
};

export default Header;
